import Backbone from 'backbone';
import Chaplin from 'chaplin';
import Question from 'ef/models/assessments/question';
// ## EF.Collections.QuestionsCollection
//
// Collection for the questions in a survey or assessment
const QuestionsCollection = Chaplin.Collection.extend({
  model: Question,

  constructor: function (models, options) {
    Backbone.Collection.apply(this, [models, options]);
  },
});

export default QuestionsCollection;
